export const WebLoginSDKName = 'js/rl-login-sdk-v2.min.js';
export enum WebLoginMode {
    Regular = 'pwd',
    FitToPlay = 'fit-to-play',
}
